export default "__VITE_ASSET__CTrXsQQH__"